import type { ServerConfig } from '@/@types';

export const serverConfig: ServerConfig = {
  subject: '预发布环境',
  environment: 'ppe',
  apiSrc: 'https://ppe-saas-api.vansunscience.com',
  questionarySrc: 'https://ppe-que-design-lite.vansunscience.com',
};
